import { toast } from "react-toastify";
import { capitalize } from "./capitalize";

export const serverMessage = (payload: any) => {
  try {
    if (payload.message === "Network Error") {
      toast.error(
        `${payload.message}: Please check your network and try again!`,
        { autoClose: 8000 }
      );
    } else if (payload.message === "timeout exceeded") {
      const capitalizeMsg = capitalize(payload.message);
      toast.error(
        `${capitalizeMsg}! Please check your network and try again!`,
        { autoClose: 8000 }
      ); // Timeout error
      // My own server returned message
    } else if (!payload.response.data.success) {
      toast.error(payload.response.data.message, { autoClose: 8000 });
    } else if (payload.message.includes(429)) {
      toast.error(payload.response.data, { autoClose: 8000 }); // Request exceeds limit error
    } else if (payload.response.data.message.includes("ETIMEDOUT")) {
      toast.error(
        "Connection timed out. Please check your network and try again",
        { autoClose: 8000 }
      );
    } else if (payload.code.includes("ERR_BAD_RESPONSE")) {
      toast.error(
        `Something went wrong. Please check your network and try again!`,
        { autoClose: 8000 }
      );
    } else if (
      payload.response.data.error.includes("getaddrinfo ENOTFOUND") ||
      payload.response.data.error.includes("connect ETIMEDOUT")
    ) {
      toast.error(
        `Something went wrong. Please check your network and try again!`,
        { autoClose: 8000 }
      );
    }
  } catch (error: any) {
    toast.error(`Something went wrong. Please, try again later!`, {
      autoClose: 8000,
    });
  }
};
